<template>
  <div class="perfil-page">

    <!-- Cabeçalho -->
    <header class="header">
      <button class="btn-voltar" @click="$router.back()">
        <i class="fas fa-arrow-left"></i> Voltar
      </button>
      <h1 class="titulo">Perfil do Funcionário</h1>
    </header>

    <!-- Loading -->
    <div v-if="loading" class="loading-state">
      <div class="spinner"></div>
      <p>Carregando dados...</p>
    </div>

    <!-- Conteúdo -->
    <div v-else class="perfil-card">
      
      <!-- Avatar -->
      <div class="avatar">
        <span>{{ iniciais }}</span>
      </div>

      <h2 class="nome">{{ form.nome }}</h2>

      <!-- FORMULÁRIO -->
      <div class="grid-info">

        <div class="info-item">
          <label>Nome</label>
          <input v-model="form.nome" class="input-edit" />
        </div>

        <div class="info-item">
          <label>Email</label>
          <input v-model="form.email" class="input-edit" />
        </div>

        <div class="info-item">
          <label>CPF</label>
          <input v-model="form.cpf" class="input-edit" maxlength="14" />
        </div>

        <div class="info-item">
          <label>Vínculo</label>
          <select v-model="form.vinculo" class="input-edit">
            <option value="Celetista">Celetista</option>
            <option value="PJ">PJ</option>
            <option value="Estagiário">Estagiário</option>
          </select>
        </div>

        <div class="info-item">
          <label>Cargo</label>
          <input v-model="form.cargo" class="input-edit" />
        </div>

        <div class="info-item">
          <label>Carga Horária Semanal (h)</label>
          <input v-model.number="form.carga_horaria_semanal" type="number" class="input-edit" />
        </div>

        <div class="info-item">
          <label>Carga Horária Mensal (h)</label>
          <input v-model.number="form.carga_horaria_mes" type="number" class="input-edit" />
        </div>

        <div class="info-item">
          <label>Salário (R$)</label>
          <input v-model="form.salario" type="number" step="0.01" class="input-edit" />
        </div>

        <div class="info-item">
          <label>CBO</label>
          <input v-model="form.cbo" type="number" class="input-edit" />
        </div>

        <div class="info-item">
          <label>Data de Admissão</label>
          <input 
            v-model="form.data_admissao" 
            type="date" 
            class="input-edit" 
          />
        </div>

      </div>

      <!-- Ações -->
      <div class="actions">
        <button class="btn-secundario" @click="$router.back()">Cancelar</button>
        <button class="btn-principal" @click="salvar" :disabled="saving">
          <i class="fas fa-save"></i>
          {{ saving ? "Salvando..." : "Salvar Alterações" }}
        </button>
      </div>

      <p v-if="message" :class="['msg', success ? 'msg-sucesso' : 'msg-erro']">
        {{ message }}
      </p>

    </div>
  </div>
</template>

<script>
import { adminService } from "@/services/adminService";

export default {
  name: "FuncionarioPerfil",
  data() {
    return {
      funcionario: null,
      loading: true,
      saving: false,
      message: "",
      success: false,

      form: {
        nome: "",
        email: "",
        cpf: "",
        vinculo: "",
        cargo: "",
        carga_horaria_semanal: "",
        carga_horaria_mes: "",
        salario: "",
        data_admissao: "",
        cbo: ""
      }
    };
  },

  computed: {
    iniciais() {
      if (!this.form.nome) return "?";
      const partes = this.form.nome.split(" ");
      return (partes[0][0] + (partes[1]?.[0] || "")).toUpperCase();
    }
  },

  methods: {
    async carregarDados() {
      const id = this.$route.params.id;

      try {
        const res = await adminService.obterFuncionarioPorId(id);
        this.funcionario = res.data;

        // Copia para o formulário
        this.form = { ...res.data };

        // Converte data para YYYY-MM-DD
        if (this.form.data_admissao) {
          this.form.data_admissao = this.form.data_admissao.split("T")[0];
        }

      } catch (e) {
        alert("Erro ao carregar funcionário.");
      } finally {
        this.loading = false;
      }
    },

    async salvar() {
      this.saving = true;
      this.message = "";

      try {
        const id = this.funcionario.id;
        await adminService.atualizarFuncionario(id, this.form);

        this.success = true;
        this.message = "Dados atualizados com sucesso!";

      } catch (e) {
        this.success = false;
        this.message = e.response?.data?.detail || "Erro ao salvar.";
      } finally {
        this.saving = false;
      }
    }
  },

  mounted() {
    this.carregarDados();
  }
};
</script>

<style scoped>
/* Container geral */
.perfil-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem 1rem;
  background: #f8fafc;
  min-height: 100vh;
  font-family: "Inter", sans-serif;
}

/* Cabeçalho */
.header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}
.btn-voltar {
  background: none;
  border: none;
  color: #3b82f6;
  cursor: pointer;
  font-weight: 600;
}
.titulo {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
}

/* Card */
.perfil-card {
  background: white;
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
}

/* Avatar */
.avatar {
  width: 100px;
  height: 100px;
  background: #3b82f6;
  color: white;
  border-radius: 50%;
  font-size: 2.5rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
}

.nome {
  text-align: center;
  font-weight: 700;
  font-size: 1.3rem;
  margin-bottom: 1rem;
}

/* Grid */
.grid-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 1rem;
}

.info-item {
  display: flex;
  flex-direction: column;
}
.info-item label {
  font-size: 0.8rem;
  margin-bottom: 4px;
  color: #64748b;
}
.input-edit {
  padding: 0.65rem;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  font-size: 0.95rem;
}
.input-edit:focus {
  border-color: #3b82f6;
  outline: none;
  box-shadow: 0 0 0 2px rgba(59,130,246,0.15);
}

/* Botões */
.actions {
  margin-top: 1.5rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.8rem;
}
.btn-secundario {
  background: #e2e8f0;
  padding: 0.7rem 1.1rem;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-weight: 600;
}
.btn-principal {
  background: #3b82f6;
  color: white;
  padding: 0.7rem 1.2rem;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-weight: 600;
}
.btn-principal:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Mensagens */
.msg {
  margin-top: 1rem;
  padding: 0.8rem;
  text-align: center;
  border-radius: 8px;
  font-weight: 600;
}
.msg-sucesso {
  background: #dcfce7;
  color: #166534;
}
.msg-erro {
  background: #fee2e2;
  color: #991b1b;
}

/* Loading */
.loading-state { text-align: center; padding: 2rem; }
.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  margin: 0 auto 1rem;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}

@media (max-width: 480px) {
  .perfil-card {
    padding: 1.2rem;
  }
}
</style>
